import { lazyNamed } from "src/utils/lazy-named";
import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";

const AnalyticsPage = lazyNamed(
  () => import("src/pages/analytics"),
  "AnalyticsPage",
);
const chartsImport = () => import("./charts");
const ChartsRoot = lazyNamed(chartsImport, "ChartsRoot");

export const preloads: RoutePreload[] = [["/analytics", chartsImport]];

export const routes: Array<RouteObject> = [
  {
    path: "analytics",
    spacesAccess: "hidden-from-limited-view",
    element: <ChartsRoot />,
    children: [
      {
        path: "archived",
        spacesAccess: "hidden-from-limited-view",
        element: null,
      },
      {
        path: "active",
        spacesAccess: "hidden-from-limited-view",
        element: null,
      },
    ],
  },
  {
    path: "analytics/:id",
    spacesAccess: "hidden-from-limited-view",
    element: <AnalyticsPage />,
  },
];
